// extracted by mini-css-extract-plugin
export default {"container":"_0hno6CS9MSZ5ZsDgq8p3VA==","image":"U3w1hbpPTAiiypt5SEYKdg==","link":"+hVt5Ee9WyPFQud6cRpGDQ==","heading":"DXmsmoKxAjjFjdQwyYWoEg==","pill":"X81vnioc0JdVMnDcl5ce3Q=="};